import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 70px);
  overflow: auto;

  .statusDiv {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .status {
    border-radius: 50px;
    display: flex;
    padding: 5px 0;
    width: 110px;
    justify-content: center;
    color: #333c3f;
  }

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: 10px;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  .imageWebChat {
    height: 40px;
    width: 40px;
  }

  .header {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
  }
`;

export const DivIconRounded = styled.div`
  background-color: #fff;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContainerLeftModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;
  position: relative;
  height: 100%;
  top: 0px;
  content: none;
  background-color: #fff;
  padding-left: 20px;
`;

export const ContainerRightModal = styled.div`
  width: 35%;
  background: #2624cd;
  color: #fff;
  position: relative;
  height: 100%;
  top: 0px;
  content: none;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  align-items: center;

  .titleTips {
    font-size: 18px;
    font-weight: 550;
    margin-bottom: 10px;
  }

  .textTips {
    font-size: 12px;
    display: flex;
    text-align: center;
    opacity: 80%;
  }

  .topics {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 15px;
  }

  .topic {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  .divImage {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
  }

  .divVideo {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
  }

  .textTopic {
    display: flex;
    flex-direction: column;
    font-size: 14px;
  }

  .textTip {
    color: #fff;
    opacity: 70%;
    font-size: 12px;
  }
`;

export const LeftHeaderWhiter = styled.div`
  width: 65%;
  position: absolute;
  height: 100%;
  top: 0px;
  border-radius: 20px;
  background-color: #ffffff;
  border-top-right-radius: 3rem;
`;

export const ButtonEdit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  transition: all 0.2s;
  padding: 4px 10px;

  :hover {
    background-color: #024aae;
    cursor: pointer;
  }
`;

export const RefreshButton = styled.div`
  display: flex;
  justify-content: center;
`;
